import { render, staticRenderFns } from "./MeShareData.vue?vue&type=template&id=1a47d836&scoped=true"
import script from "./MeShareData.vue?vue&type=script&lang=js"
export * from "./MeShareData.vue?vue&type=script&lang=js"
import style0 from "./MeShareData.vue?vue&type=style&index=0&id=1a47d836&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a47d836",
  null
  
)

export default component.exports